import React from 'react'
import { useSelector } from 'react-redux'



function Loader() {
    const loader = useSelector((state) => state?.loader?.value)

    return (
        <>
            {loader ?
                (
                    <div className="loading">
                        <div className="lds-roller">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        <h2 style={{ color: "#2f2481" }}>Loading...</h2>
                    </div>

                )
                :
                null}
        </>
    )
}

export default Loader